import { render, staticRenderFns } from "./FormTanque.vue?vue&type=template&id=1590441c&scoped=true&"
import script from "./FormTanque.vue?vue&type=script&lang=js&"
export * from "./FormTanque.vue?vue&type=script&lang=js&"
import style0 from "./FormTanque.vue?vue&type=style&index=0&id=1590441c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590441c",
  null
  
)

export default component.exports